class CollectUserData {
  collect() {
    const browser = this.getBrowser();
    const platform = this.getPlatform();
    const deviceTime = this.getDeviceTime();
    const currentUrl = this.getCurrentUrl();

    return { browser, platform, deviceTime, currentUrl };
  }

  getBrowser() {
    const agent = navigator.userAgent;
    let browser;

    if (agent.indexOf("Opera") !== -1 || agent.indexOf("OPR") !== -1) {
      browser = "Opera";
    } else if (agent.indexOf("Chrome") !== -1) browser = "Chrome";
    else if (agent.indexOf("Safari") !== -1) browser = "Safari";
    else if (agent.indexOf("Firefox") !== -1) browser = "Firefox";
    else browser = "unknown";

    return browser;
  }

  getPlatform() {
    return navigator.platform;
  }

  getDeviceTime() {
    const currentDate = new Date();

    return currentDate.toString();
  }

  getCurrentUrl() {
    return location.href;
  }
}

export default CollectUserData;



// WEBPACK FOOTER //
// ./src/services/collectUserData/collectUserData.service.js